import Lookup from 'src/componentes/select-async';
import ColaboradorEdit from 'src/paginas/colaborador/edit';
import ColaboradorList from 'src/paginas/colaborador/view';
import Avatar from 'src/componentes/item-multi-lookup';
import Tooltip from 'src/componentes/tooltip';

const ColaboradorLookup = (props) => {
  const renderColaborador = (item) => {
    const isValid =
      item.value &&
      (typeof item.value === 'object' ? item.value.id : item.value.length > 0);

    return (
      <>
        {isValid && (
          <Avatar
            foto={item && item.value && item.value.fotoArquivo}
            size={props.size}
            onlyAvatar={props.onlyAvatar}
            disabled={props.disabled}
            avatar
            label={item.value.nome}
            onRemove={item.onRemove && (() => item.onRemove(item.value))}
            value={item.value}
            multi={props.multi}
          ></Avatar>
        )}
      </>
    );
  };

  let somenteAtivos = props.data
    ? props.data.somenteAtivos
    : !props.exibirInativos;
  const {
    selecionarAvaliador,
    processoAvaliativoId,
    avaliadoId,
    showHint,
    hint,
    optionRenderer,
  } = props;

  return (
    <Tooltip text={hint} disabled={!showHint}>
      <div>
        <Lookup
          compactMultiShowAvatar
          valueComponent={renderColaborador}
          valueKey="id"
          labelKey="nome"
          showSearch
          clearable={true}
          url="/ColaboradorLookup"
          editComponent={ColaboradorEdit}
          searchComponent={ColaboradorList}
          {...props}
          optionRenderer={optionRenderer && optionRenderer}
          data={{
            ...props.data,
            viewListSearch: true,
            somenteAtivos: somenteAtivos,
            carregarPodeSerAvaliador: selecionarAvaliador,
            processoAvaliativoId: processoAvaliativoId,
            avaliadoId: avaliadoId,
          }}
        />
      </div>
    </Tooltip>
  );
};

export default ColaboradorLookup;
